import { FC } from "react";
import { cn } from "utils";

interface LineChartSkeletonProps {
  className?: string;
}

export const LineChartSkeleton: FC<LineChartSkeletonProps> = ({
  className,
}) => {
  return (
    <div
      className={cn(
        "bg-background_white_overlay5 rounded-1 p-3 flex flex-col justify-between",
        className,
      )}
    >
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="w-full h-3 flex items-center gap-2.5 before:content-[''] before:w-6 before:h-3 before:animate-pulse before:bg-background_white_overlay5 before:rounded-1 after:content-[''] after:w-full after:h-0 after:border-dashed after:border-b-px after:border-background_white_overlay5"
        />
      ))}
      <div className="grid grid-cols-3 gap-x-3 gap-y-1 before:content-[''] before:col-span-full before:border-b before:border-solid before:border-background_white_overlay10 before:h-0 w-[calc(100%-2rem)] self-end">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="animate-pulse w-full h-3 rounded-1 bg-background_white_overlay5"
          />
        ))}
      </div>
    </div>
  );
};
